import { render, staticRenderFns } from "./esgNewsDimension.vue?vue&type=template&id=52146092&scoped=true"
import script from "./esgNewsDimension.vue?vue&type=script&lang=js"
export * from "./esgNewsDimension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52146092",
  null
  
)

export default component.exports